import { useLocation, useHistory } from "react-router-dom";
import { useQueryString } from "hooks/general-hooks";
import * as generalHelper from "lib/general-helper.js";

export const useOnFilterChange = () => {
  const location = useLocation();
  const history = useHistory();
  const queryParams = useQueryString();

  const updateQueryParams = (newFilter: object, pathName: string) => {
    const newLocation = {
      ...location,
      pathname: pathName || location.pathname,
    };

    if (pathName !== location.pathname) {
      generalHelper.updateQueryParams(history, newLocation.pathname, newFilter);
    } else {
      generalHelper.updateQueryParamsIfChanged(history, newLocation, newFilter);
    }
  };

  const onFilterChange = (filterType: string, filterValue: string, alterQueryParams = true, alterUrlPos = -1) => {
    let newFilter = { [filterType]: filterValue };
    newFilter = { ...queryParams, ...newFilter };

    let newUrl = location.pathname;
    if (alterUrlPos !== -1) {
      let splitUrl = newUrl.split("/");
      splitUrl[alterUrlPos] = filterValue;

      newUrl = "/" + splitUrl.filter((x) => x !== "").join("/");
    }

    const filterToUse = alterQueryParams ? newFilter : queryParams;
    const urlToUse = alterUrlPos !== -1 ? newUrl : location.pathname;

    updateQueryParams(filterToUse, urlToUse);
  };

  return onFilterChange;
};
